import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Poperator(){
  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
 
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python Operator Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python operators tutorial for beginners.Operators in Python are used special symbols which perform any type of operations." />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Python operator,Python and opeartor,Python operator module,Python operator string,Python not equal operator,Python operator  not equal,Python operator example,Operator in python" />
<link rel="canonical" href="https://www.codeexampler.com/python-operators/"/>
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Python Operator</h1>

    <div className="first">
        <a href="/python-comments">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-string">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


    <h2 className="mt-4 mh2">An operator in Python:</h2>
    <p className="mt-4 para">Operators in Python use special symbols that perform many types of operations.<br/>
or<br/>
Python and operator is a special symbol that uses in the expression. 
</p>


<h2 className='headings'>An Operator Syntax code in Python:</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-2">102</span>
                <span className="qwerty">/</span>
                <span className="qwerty-2">8</span>
                <span className="qwerty">%</span>
                <span className="qwerty-2">40</span>
            {"\n"}{"\n"}

            <span className="qwerty-1">(</span>
        
            <span className="qwerty-10">+-/%</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-4"> Operator Symbol </span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>  




<h2 className='headings'>An Operator Syntax code in Python:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">b</span>
             {"\n"}
                 <span className="qwerty-8">  so</span>
             {"\n"}
                 <span className="qwerty">=</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-2"> are an</span>
                 <span className="qwerty-3"> operator</span>
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-2"> are an</span>
                 <span className="qwerty-3"> operand</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div>     




<h2 className='headings'>An Operator Syntax code in Python:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">d</span>
             {"\n"}
                 <span className="qwerty-11"> above in this line of code  </span>
             {"\n"}
                 <span className="qwerty">=</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-2"> are </span>
                 <span className="qwerty-3"> operators</span>
                 <span className="qwerty-2"> means there are </span>
                 <span className="qwerty-3">TWO </span>
                 <span className="qwerty-2">operators. </span>
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">d</span>
                 <span className="qwerty-2"> are an</span>
                 <span className="qwerty-3"> operand</span>
                 <span className="qwerty-2"> means there are </span>
                 <span className="qwerty-3">FOUR </span>
                 <span className="qwerty-2">operands. </span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div>         




<h2 className='headings'>An Operator Syntax code in Python:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty">-</span>
                 <span className="qwerty-4">d</span>
             {"\n"}
                 <span className="qwerty-11"> above in this line of code  </span>
             {"\n"}
                 <span className="qwerty">=</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty">-</span>
                 <span className="qwerty-2"> are </span>
                 <span className="qwerty-3"> operators</span>
                 <span className="qwerty-2"> means there are </span>
                 <span className="qwerty-3">THREE </span>
                 <span className="qwerty-2">operators. </span>
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">d</span>
                 <span className="qwerty-2"> are an</span>
                 <span className="qwerty-3"> operand</span>
                 <span className="qwerty-2"> means there are </span>
                 <span className="qwerty-3">FOUR </span>
                 <span className="qwerty-2">operands. </span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div>   

<h2 className="mt-4 mh2">1, Arithmetic operator:</h2>
<h3 className="mt-4 mh3">+ add<br/>
-Sub<br/>
Multiply<br/>
/ division<br/>
% modules<br/>
++ increment<br/>
-- decrement<br/>
</h3>


<h2 className='headings'>Arithmetic Operator Example code in Python</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">10</span>
             {"\n"}
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">20</span>
             {"\n"}
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">b</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-10">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-10">)</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-8">30</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>



<h2 className='headings'>Arithmetic Operator Example code in Python</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-10"> #Addition</span>
             {"\n"}
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">-</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-10">#Subtraction</span>
             {"\n"}
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">*</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-10"> #Multiplication</span>
             {"\n"}
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">/</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-10"> #Divison</span>
             {"\n"}
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">%</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-10"> #Remainder</span>
             {"\n"}
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">++</span>
                 <span className="qwerty-8">  or  </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">--</span>
                 <span className="qwerty-10"> #Incrementation or Decrementation by 1</span>
             {"\n"}
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty">++</span>
                 <span className="qwerty-8">  or  </span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty">--</span>
                 <span className="qwerty-10"> #Incrementation or Decrementation by 1</span>
             {"\n"}
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">**</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-10"> #Power</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div>       


<h2 className="mt-4 mh2">2,Relational operator:</h2>
<h3 className="mt-4 mh3"> Greater than  <br/>
&#60;less than <br/>
&#62;=greater than or equal to<br/>
&#60;= -less than or equal to<br/>
!= - not equal to<br/>
== -equal to<br/>
</h3>


<h2 className='headings'>Relational Operator Example code in Python:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">10</span>
             {"\n"}
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">20</span>
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">&#60;=</span>
                 <span className="qwerty-4">b</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">b is greater</span>
                 <span className="qwerty-1">")</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-1">b</span>
                        <span className="qwerty-3"> is greater</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>


<h2 className='headings'>Relational Operator Example code in Python</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">20</span>
             {"\n"}
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">20</span>
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">&#60;=</span>
                 <span className="qwerty-4">b</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">both equal</span>
                 <span className="qwerty-1">")</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-3">both equal</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>

<h2 className="mt-4 mh2">3, Logic operator:</h2>
<h3 className="mt-4 mh3">and  &#38;&#38;<br/>
or   &#124;&#124;<br/>
not&#33;
</h3>



<h2 className='headings'>Logical Operator Example code in Python:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">20</span>
             {"\n"}
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">40</span>
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty"> and </span>
                 <span className="qwerty-4">b</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">b is greater</span>
                 <span className="qwerty-1">")</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-1">b </span>
                        <span className="qwerty-3">is greater </span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>

<h2 className="mt-4 mh2">4, Bitwise operator:</h2>
<h3 className="mt-4 mh3">
&#62;&#62; - right shift<br/>
    &#60;&#60; - left shift<br/>
^ xor<br/>
~ B Not<br/>
</h3>

<h2 className="mt-4 mh2">5, Assignment operator:</h2>
<h3 className="mt-4 mh3">=<br/>
+=<br/>
-=<br/>
*=<br/>
/=<br/>
%=<br/>
&#47;&#47;=<br/>
**=<br/>
&#38;=<br/>
&#60;&#60;=<br/>
&#62;&#62;=<br/>
^=<br/>
</h3>

<h2 className="mt-4 mh2">6, Identifier Operator in python:</h2>



<h2 className='headings'>Python Operator Example Code:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">5</span>
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span> 
                 <span className="qwerty">*</span>
                 <span className="qwerty-2">4</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-2">20</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>



<h2 className='headings'>Python Operator Example Code:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">4</span>
             {"\n"}
                 <span className="qwerty-4">y</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">4</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty"> is </span>
                 <span className="qwerty-4">y</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty"> is </span>
                 <span className="qwerty-7">not </span>
                 <span className="qwerty-4">y</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-6">True</span>
                    {"\n"}
                        <span className="qwerty-6">False</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>

  <h1 className="mt-5">  </h1>
     
  <div className="back">
        <a href="/python-comments"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-string"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Poperator;